import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'

const headers = new HttpHeaders({
  'Content-Type':  'application/json',
  'Accept': 'application/json',
  // 'Authorization':'Bearer eyJhbGciOiJFQ0RILUVTK0ExMjhLVyIsImVuYyI6IkExMjhDQkMtSFMyNTYiLCJraWQiOiJSZWNlcHRvciIsImN0eSI6IkpXVCIsImVwayI6eyJrdHkiOiJFQyIsIngiOiJkWkhQbGEtYTdyMEhUYXg3ZHJLVl9DeWRMYUNPM1lQa2VjWFg5bm1mLXBZIiwieSI6Iko4ZV81RHc4YVVUeXFsOTM0TXJRUWRUN2YzUnNoY3RKTDhhUDBEX2FEOFkiLCJjcnYiOiJQLTI1NiJ9fQ.J4jNX_WousxoDDSqF2GxeJBLWw03JbX5COowI26rkWvy8eY-fBgHHw.d74JxC9HBC3pDH6dgZ37Tw.YpdvSqg7jBZOn5jYSddS6UvUH_de3m9gy2enBLdumTST2fZYbf3rqduTdy3LCy6vOhRn8UW0ksPevVCmOLwvPjliBmZM3gQ-8L9Tsh1n3-MO8pdPkgi_ZfdKi_hIpr8eOc-57mPM75lr6ktdUR2W4cnuTTn3W_QjzinRdvXQ3BIEJlSHqgYH0URGYnsMUPuwI0zFpmfkNEzRFc1MaLiA9WbpwCqXytqPahkQooT5Xxy4J8YpbymfOxDnId3KTqoqiGkl1OLWF3lPRm9woIBK_mJO_DyX9daLRqcrNF8HJXp9EVH8MyU1JYzixKkmv7gxXBwwi8yJpXvzpfRkhM7ooK97nXT3zhvQZXl4fA6sxRWWMYVrm2FOEjE7R0pAsDUVbEdDiaYhjvByJPsZZ_QKPNPAs-mX0cJo2He82cKvRzQHKtAA9KaCxGfxYiASnPzV.Px5aWtv2tpmyK8wxVygCFA'
})


@Injectable({
  providedIn: 'root'
})

export abstract class RestService<T> {
    
  constructor (public http: HttpClient) { 
      
  }

  get (url: string, params?: HttpParams): Observable<T[]> {
    let options = {
        params: params,
        headers: headers
    }
    return this.http.get<T[]>(url, options)
  }

  post (url: string, body?: T): Observable<T> | any {
    
    return this.http.post<T>(url, body, {
      headers: headers
    })
  }

  update (url: string, body: T): Observable<T> | any {
    return this.http.put<T>(url, body, {
      headers: headers
    })
  }

  delete (url: string): any {
    return this.http.delete(url, {
      headers: headers
    })
  }

  /* HELPERS */

  listar (url: string, params?: HttpParams): Observable<T[]> {
    return this.get(url, params)
  }

  criar (url: string, body: T): Observable<T> | any {
    return this.post(url, body)
  }

  atualizar (url: string, body: T): Observable<T> | any {
    return this.update(url, body)
  }

  deletar (url: string): any {
    return this.delete(url)
  }
 
}